import { gql } from '@efficiently/client-core-graphql-models';

export const UPDATE_PLAN_ITEM = gql(`
	mutation UpdatePlanItem($planItem: PlanItemInput!, $roundLine: String!, $roundArea: String!) {
		updatePlanItem(planItem: $planItem, roundLine: $roundLine, roundArea: $roundArea) {
			planItem {
				...PlanItemFields
			}
			constructions {
				...ConstructionFields
			}
			finishes {
				...FinishDomainFinishFields
			}
		}
	}
`);
